<div class="flex flex-col items-start p-8 border-b">
    <!-- Retorno -->
    <a class="inline-flex items-center leading-6 text-primary hover:underline" [routerLink]="validarRouter()">
        <span class="inline-flex items-center">
            <mat-icon
                class="icon-size-5 text-current"
                [svgIcon]="'heroicons_solid:arrow-sm-left'"></mat-icon>
            <span class="ml-1.5 font-medium leading-5">Regresar</span>
        </span>
    </a>
    <!-- Wizard Folio-->
    <div class="mt-3 text-secondary" *ngIf="informacionWizard?.folioNegocio && !informacionWizard?.folioDiligencia">
        {{informacionWizard?.folioNegocio}}
    </div>
    <div class="mt-3 text-secondary" *ngIf="informacionWizard?.folioDiligencia">
        {{informacionWizard?.folioDiligencia}}
    </div>
    <!-- Wizard titulo y descripción -->
    <div class="mt-3 text-2xl font-semibold">{{informacionWizard?.titulo}}</div>
    <div class="text-secondary">{{informacionWizard?.descripcion}}</div>
    <!-- Wizard Información -->
    <ng-container *ngIf="informacionWizard?.idWizardGenerado">
        <div
            class="mt-7 py-0.5 px-3 rounded-full text-sm font-semibold"
            ngClass="'text-blue-800 bg-blue-100 dark:text-blue-50 dark:bg-blue-500'">
            {{informacionWizard?.categoria}}
        </div>
    </ng-container>
    <!-- Wizard Tiempo -->
    <div class="mt-6 flex items-center leading-5 text-md text-secondary" *ngIf="false">
        <mat-icon
            class="icon-size-5 text-hint"
            [svgIcon]="'heroicons_solid:clock'"></mat-icon>
        <div class="ml-1.5"> 00 Hrs. 00 Min. 00 Seg.</div>
    </div>
</div>
